module.exports = __webpack_public_path__ + "img/logo-keyvue-legacy.36e74546.svg";